import React from 'react';

export default function BusinessModel() {
  return (
    <section className="w-full bg-black text-white py-20 px-6 md:px-10">
      <div className="max-w-6xl mx-auto space-y-14">

        {/* Section Title */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Business Model</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            M2T is designed for multi-layer monetization across professional roles, services, and investor engagement.
          </p>
        </div>

        {/* Revenue Streams */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-gray-300 text-base">

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📦 Role-Based SaaS</h3>
            <p>
              Monthly/annual plans with feature access based on verified roles — traders, mentors, brokers, researchers, etc.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">🛒 Marketplace Commissions</h3>
            <p>
              M2T takes a fee on completed services, gigs, or role-verified transactions inside the ecosystem.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">💼 Investor Access & Tools</h3>
            <p>
              Verified investors pay for premium access to talent, dashboards, signals, dealflow, or compliance data.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📊 Signal Monetization</h3>
            <p>
              Strategy creators can sell, license, or bundle their signals via SmartCard-powered revenue contracts.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6">
            <h3 className="text-xl text-white font-semibold mb-2">📚 Licensing & B2B Dashboards</h3>
            <p>
              White-label modules and role-specific dashboards for financial firms, educators, or brokers.
            </p>
          </div>

        </div>

        {/* Future Layers */}
        <div className="text-center pt-12">
          <h3 className="text-2xl font-semibold text-white mb-4">Future Monetization Layers</h3>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">
            AI strategy builders, micro-promotion engines, compliance APIs, and SmartCard-linked advertising are all on the roadmap — creating defensibility and growth at scale.
          </p>
        </div>

      </div>
    </section>
  );
}
